<template>
  <div class="details-wrapper">
    <checkout-payment-box>
      <template #title>
        <checkout-payment-headline :title="$t('checkout.payment.infoAboutUser')"/>
      </template>
      <div class="checkout-payment-form">
        <div class="checkout-payment-input">
          <base-v-input v-model="$props.value.firstName"
                        :label="$t('form.firstName')"
                        :submitted="$props.formSubmitted"
                        rules="required"/>
        </div>
        <div class="checkout-payment-input">
          <base-v-input v-model="$props.value.lastName"
                        :label="$t('form.lastName')"
                        :submitted="$props.formSubmitted"
                        rules="required"/>
        </div>
        <div class="checkout-payment-input">
          <base-v-input v-model="$props.value.phone"
                        :label="$t('form.contactNumber')"
                        :submitted="$props.formSubmitted"
                        rules="required|phoneNumberWithSpaces|max:15"
                        :maxlength="(13 + countSpecialChars).toString()"/>
        </div>
        <div class="checkout-payment-input">
          <base-v-input v-model="$props.value.jmbg"
                        :label="$t('form.jmbg')"
                        :submitted="$props.formSubmitted"
                        rules="required|digits:13|jmbg"
                        maxlength="13"
                        :disabled="jmbgDisabled"/>
        </div>
        <div class="checkout-payment-input">
          <base-v-input v-model="$props.value.email"
                        :label="$t('form.email')"
                        :submitted="$props.formSubmitted"
                        rules="required|email"/>
        </div>
        <div v-if="$props.registrationAvailable" class="checkout-payment-checkbox">
          <base-checkbox variant="green"
                         :label="$t('form.createAccount')"
                         :value="$props.value.createAccount"
                         @change="$props.value.createAccount = !$props.value.createAccount"/>
        </div>
        <transition name="expand" mode="out-in">
          <div v-if="showPasswordFields" class="checkout-payment-input" key="password">
            <validate-password-dropdown :visible="passwordFocus"
                                        :password="$props.value.password">
              <base-v-input v-model.trim="$props.value.password"
                            id="password"
                            name="password"
                            rules="required|password"
                            :label="$t('form.password')"
                            :submitted="$props.formSubmitted"
                            revealPassword
                            type="password"
                            maxlength="20"
                            vid="password"
                            @focus="passwordFocus = true"
                            @blur="passwordFocus = false"/>
            </validate-password-dropdown>
          </div>
        </transition>
        <transition name="expand" mode="out-in">
          <div v-if="showPasswordFields" class="checkout-payment-input" key="confirm-password">
            <validate-password-dropdown :visible="confirmPasswordFocus"
                                        :password="$props.value.confirmPassword">
              <base-v-input v-model.trim="$props.value.confirmPassword"
                            id="confirmPassword"
                            name="confirmPassword"
                            rules="required|confirmPassword:@password"
                            :label="$t('form.confirmPassword')"
                            :submitted="$props.formSubmitted"
                            revealPassword
                            type="password"
                            maxlength="20"
                            vid="confirmPassword"/>
            </validate-password-dropdown>
          </div>
        </transition>
      </div>
    </checkout-payment-box>
    <checkout-payment-box>
      <span class="box-inner-title">{{ $t('checkout.payment.address') }}</span>
      <div class="checkout-payment-form">
        <div class="checkout-payment-input">
          <base-v-input v-model="$props.value.line1"
                        :label="$t('form.street')"
                        :submitted="$props.formSubmitted"
                        rules="required"/>
        </div>
        <div class="checkout-payment-input half-width">
          <base-v-input v-model="$props.value.line2"
                        :label="$t('form.streetNumber')"
                        :submitted="$props.formSubmitted"
                        rules="required"/>
        </div>
        <div class="checkout-payment-input half-width">
          <base-v-input v-model="$props.value.postalCode"
                        :label="$t('form.zipCode')"
                        :submitted="$props.formSubmitted"
                        rules="required|numeric"/>
        </div>
        <div class="checkout-payment-input select">
          <label>{{ $t('form.city') }}</label>
          <v-select class="select-dropdown grey"
                    v-model="$props.value.town"
                    :options="$props.cities"
                    :searchable="false"
                    label="name"/>
        </div>
        <div class="checkout-payment-input textarea">
          <label for="remarks">{{ $t('form.note') }}</label>
          <textarea v-model="$props.value.remarks"
                    name="remarks"
                    id="remarks"
                    rows="3"/>
        </div>
      </div>
    </checkout-payment-box>
  </div>
</template>

<script>
import BaseVInput from '@/components/base/base-v-input'
import BaseCheckbox from '@/components/base/base-checkbox'
import CheckoutPaymentBox from './checkout-payment-box'
import CheckoutPaymentHeadline from './checkout-payment-headline'
import ValidatePasswordDropdown from '@/components/common/validate-password-dropdown'
import vSelect from 'vue-select'

export default {
  name: 'checkout-payment-details',
  components: {
    BaseVInput,
    BaseCheckbox,
    CheckoutPaymentBox,
    CheckoutPaymentHeadline,
    ValidatePasswordDropdown,
    vSelect
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    cities: {
      type: Array,
      default: () => []
    },
    registrationAvailable: Boolean,
    formSubmitted: Boolean
  },
  data () {
    return {
      passwordFocus: false,
      confirmPasswordFocus: false,
      jmbgDisabled: false
    }
  },
  computed: {
    countSpecialChars () {
      if (this.$props.value.phone.startsWith('00')) {
        return Math.min(this.value.phone.replace(/[0-9a-zA-Z]/g, '').length + 2, 5)
      }
      return Math.min(this.value.phone.replace(/[0-9a-zA-Z]/g, '').length, 5)
    },
    showPasswordFields () {
      return this.$props.value.createAccount && this.$props.registrationAvailable
    }
  },
  mounted () {
    // nextTick ne radi iz nekog razloga, mozda ne bi bilo lose proveriti kasnije zasto
    setTimeout(() => {
      this.jmbgDisabled = !!this.$props.value?.jmbg
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.details-wrapper {
  margin-bottom: 3rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 4rem;
  }
}

.checkout-payment-form {
  margin: 0 -2rem;
  @media (map_get($breakpoints, sm)) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}

.checkout-payment-input, .checkout-payment-checkbox {
  margin: 0 2rem;
  @media (map_get($breakpoints, sm)) {
    flex: 0 0 calc(50% - 4rem);
  }

  &.half-width {
    display: inline-block;
    width: calc(50% - 4rem);

    @media (map_get($breakpoints, sm)) {
      flex: 0 0 calc(25% - 4rem);
      width: calc(25% - 4rem);
    }
  }

  &.select {
    margin-bottom: 3rem;

    @media (map_get($breakpoints, sm)) {
      margin-bottom: auto;
    }
  }

  &.textarea {
    margin-bottom: 3rem;
  }
}

.checkout-payment-checkbox {
  margin-bottom: 2.4rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: .4rem;
  }
}

.box-inner-title {
  display: block;
  margin-bottom: 1.6rem;
  color: $black;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 1.4rem;
    color: $text;
    font-size: 2.4rem;
  }
}
</style>
